export default __webpack_public_path__ + "static/media/ag.ca92e98b.svg";